export { default } from './B2CLoginSocialButtons';
